export const PREDEFINED_URLS = [
  'localhost:4200',
  'localhost:5000',
  'localhost:4',
  'env-customer-panel.jcloud.ik-server.com',
  'resto.tapgo.ch',
  'smashed.ch',
  'demo.resto.tapgo.ch',
];
